import { Group } from '@/components/_common';
import { useSpedDocumentSendToPlugStorage } from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import { SpedDocumentStatus } from '@/core/domain/sped/sped-documents/sped-documents.types';
import {
  useSpedDocumentContext,
  useSpedDocumentHasItemContext,
} from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import { Button, Col, Modal } from 'antd';
import { RefreshCw } from 'react-feather';

export default function SpedDocumentSendToPlugStorage() {
  const spedDocument = useSpedDocumentContext();

  const [hasItemsPendingOrError] = useSpedDocumentHasItemContext();

  const enabled =
    spedDocument?.status === SpedDocumentStatus.ASSESSING &&
    hasItemsPendingOrError;

  const sendToPlugStorage = useSpedDocumentSendToPlugStorage();

  const handleSubmit = async () => {
    try {
      if (!spedDocument) return;

      await sendToPlugStorage.mutateAsync(spedDocument?.id);
    } catch {}
  };

  const confirmModal = () => {
    Modal.confirm({
      title: 'Confirmação de reenvio',
      content:
        'Todos os arquivos que estão pentendes e com erros serão reenviados para apuração, deseja continuar?',
      okText: 'Continuar',
      onOk: handleSubmit,
    });
  };

  if (!enabled) return null;

  return (
    <Col span={24} sm={12} md={8} lg={5}>
      <Button onClick={confirmModal} block>
        <Group gap={0} position="center">
          <RefreshCw size={14} />
          <span>Reenviar arquivos</span>
        </Group>
      </Button>
    </Col>
  );
}
